import { put } from '../../base-portal-api';

import { UserSettings } from './types-update-settings';

export function updateUserSettings(request: UserSettings): Promise<void> {
  return put('v1/user/settings', { json: request }).json();
}
